import React, { FC } from 'react'
import styles from './CuratedDeals.module.scss'

const Header: FC = () => {
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>Curated Deals</h1>
      <p className={styles.subtitle}>
        New each week: 20 curator-approved original artworks from our bestselling artists, offered
        at reduced, limited-time prices.
      </p>
    </div>
  )
}

export default Header
